var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStoriesShareFacebook = function SvgStoriesShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M17.768 7.5H13.5V5.595c0-.896.594-1.105 1.012-1.105H17.5V.548L13.171.535C9.244.535 8.5 3.473 8.5 5.355V7.5h-3v4h3v12h5v-12h3.851z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h24v24H-1z"
  }))));
};
export default SvgStoriesShareFacebook;